'use es6';

/**
 * Fork of UIComponents/nav/UINavItemLabel
 * https://git.hubteam.com/HubSpot/UIComponents/blob/f5f8211/UIComponents/static-3.2955/js/nav/UINavItemLabel.js
 */
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "count"];
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import styled from 'styled-components';
import { NAV_ITEM_INNER_SPACING_X } from 'HubStyleTokens/sizes';
import { isRenderable } from 'UIComponents/utils/propTypes/componentProp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledNavItemLabel = styled.span.withConfig({
  displayName: "NavItemLabel__StyledNavItemLabel",
  componentId: "sc-1mj80mc-0"
})(["align-items:center;display:flex;flex-grow:1;"]);
const Count = styled.span.withConfig({
  displayName: "NavItemLabel__Count",
  componentId: "sc-1mj80mc-1"
})(["margin-left:auto;padding-left:", ";"], NAV_ITEM_INNER_SPACING_X);
class NavItemLabel extends Component {
  render() {
    const _this$props = this.props,
      {
        children,
        className,
        count
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsxs(StyledNavItemLabel, Object.assign({}, rest, {
      className: className,
      children: [/*#__PURE__*/_jsx(Fragment, {
        children: children
      }), isRenderable(count) && /*#__PURE__*/_jsx(Count, {
        children: count
      })]
    }));
  }
}
NavItemLabel.displayName = 'NavItemLabel';
NavItemLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  count: PropTypes.node
};
export default NavItemLabel;